import { render, staticRenderFns } from "./general-page.vue?vue&type=template&id=2c52d3a4"
import script from "./general-page.vue?vue&type=script&lang=js"
export * from "./general-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports